import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { ArticleService } from '../services/article.service'
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent implements OnInit {
  getFullYear: number = new Date().getFullYear();
  keywords: string;
  perPage = 10;
  page = 1;
  title:any;
  loading = true; 
  total:number;
  article:any=[];
  notscrolly = true;
  notEmptyPost = true;
  isCollapsed = false;
  constructor(
    private readonly routerLinkActive: ActivatedRoute,
    private articleService: ArticleService
  ) { }

  ngOnInit() {
   this.routerLinkActive.queryParamMap.subscribe(
      (paramMap: ParamMap) => {
        this.keywords = paramMap.get("keyword");
        this.search(this.perPage, this.page, this.keywords)
      }
    );
  }

search(perPage:number, page:number, title:string){
  this.loading = false;
  this.articleService.search(perPage, page, title).subscribe((res:any)=>{
    this.loading = false;
    this.total = res.data.total;
    this.article = res.data.docs;
  });
}

onPageIndexChange($event) {
  this.search(this.perPage, $event, this.keywords);
  window.scroll(0,0);
}

}
